<template>
  <div class="z-border-red mb-2">
    <div
      class="pt-2 lighten-3"
      :class="item.status == 'Approve' ? 'green' : item.status == 'Reject' ? 'red' : 'grey'"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px"
    ></div>
    <div class="pa-2">
      <v-layout>
        <v-flex>
          <v-checkbox
            v-model="item.selected"
            :label="`${item.redeem_detail}`"
            class="mt-0"
            color="primary"
          ></v-checkbox>
          <!-- <div class="title primary--text">{{ item.redeem_detail }}</div> -->
        </v-flex>
        <v-flex shrink style="white-space: nowrap">
          <v-dialog v-model="showPhoto" max-width="600">
            <template v-slot:activator="{ on }">
              <v-btn
                outline
                small
                color="primary"
                :disabled="!photourl || photourl == null || photourl == ''"
                class="ma-0 mb-2"
                v-on="on"
              >
                <v-icon class="mr-2">search</v-icon>View
              </v-btn>
            </template>
            <v-card v-if="showPhoto">
              <div class="text-xs-right">
                <v-btn fab flat small @click="showPhoto = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="text-xs-center">
                <template v-if="photourl && photourl.length > 0">
                  <div class="pa-1" v-if="selectedImage">
                    <img
                      :src="selectedImage"
                      style="width: 100%; max-width: 600px; border: 1px solid #eee"
                    />
                  </div>
                  <v-layout wrap>
                    <template v-for="(item, i) in photourl">
                      <v-flex
                        v-if="item"
                        :key="i"
                        xs3
                        @click="selectedImage = item"
                        style="cursor: pointer"
                        class="pa-1"
                      >
                        <v-card flat>
                          <v-img
                            :src="item"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            style="border: 1px solid #eee"
                          >
                            <template v-slot:placeholder>
                              <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                        </v-card>
                      </v-flex>
                    </template>
                  </v-layout>
                </template>
                <template v-else>No images</template>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn
            outline
            small
            color="primary"
            :disabled="isEdit"
            @click="sendToEmployee"
            class="ma-0 mb-2"
          >
            <v-icon class="mr-2">send</v-icon>Send
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="caption grey--text">
          {{ item.redeem_date | dateFormat('DD MMM YYYY') }}
        </v-flex>
        <v-flex class="text-xs-right title mb-2">{{ item.redeem_point | numberFormat }}</v-flex>
      </v-layout>
      {{ item.emp_first_name }} {{ item.emp_last_name }}
      <span class="caption">{{ item.emp_id ? `(${item.emp_id})` : '' }}</span>
      <v-layout>
        <v-flex>
          <div class="caption" v-if="!isEdit">
            {{ item.remark ? item.remark : 'Edit Remark' }}
            <v-btn @click="onEditRemark" small class="extra-small" flat fab>
              <v-icon>edit</v-icon>
            </v-btn>
          </div>
          <div v-else class="form-control">
            <v-layout>
              <input type="text" v-model="item.remark" :placeholder="$t('Remark')" />
              <v-btn fab small class="extra-small" outline @click="onCancelRemark">
                <v-icon>close</v-icon>
              </v-btn>
              <v-btn fab small class="extra-small" outline @click="onSaveRemark">
                <v-icon>check</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </v-flex>
        <v-flex class="pl-1" style="max-width: 200px">
          <div class="text-xs-right">
            <multiselect
              v-model="status"
              :options="statusOption"
              label="label"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              track-by="label"
              @select="onSelectStatus"
              :disabled="status.value != ''"
            ></multiselect>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
export default {
  props: ['value'],
  data() {
    return {
      isEdit: false,
      item: this.value,
      status: {
        label: 'Not Assign',
        value: ''
      },
      statusOption: [
        {
          label: 'Not Assign',
          value: ''
        },
        {
          label: 'Approve',
          value: 'Approve'
        },
        {
          label: 'Reject',
          value: 'Reject'
        }
      ],
      showPhoto: false,
      selectedImage: null
    }
  },
  components: {
    Multiselect
  },
  computed: {
    photourl() {
      if (this.item.photourl) {
        var photo = this.item.photourl.split(',')
        if (photo.length > 0) {
          this.selectedImage = photo.find((el) => {
            return el != null
          })
        }
        return photo
      } else {
        return []
      }
    }
  },
  mounted() {
    var vm = this
    var status = vm.statusOption.find((el) => {
      return el.value == vm.item.status
    })
    if (status) {
      vm.status = status
    } else {
      vm.status = vm.statusOption[0]
    }
  },
  methods: {
    sendToEmployee() {
      var vm = this
      vm.$swal
        .fire({
          title: 'Do you want to send message to employee?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.saveHafeleRedeemDetail(true).then(() => {})
          }
        })
    },
    onCancelRemark() {
      var vm = this
      vm.item = JSON.parse(vm.cached_item)
      vm.isEdit = false
    },
    onSaveRemark() {
      var vm = this
      vm.saveHafeleRedeemDetail(false).then(() => {
        vm.cached_item = JSON.stringify(vm.item)
        vm.isEdit = false
      })
    },
    onEditRemark() {
      this.cached_item = JSON.stringify(this.item)
      this.isEdit = true
    },
    onSelectStatus(status) {
      var vm = this
      vm.status = status
      vm.saveHafeleRedeemDetail(false).then(() => {
        vm.item.status = status.value
      })
    },
    saveHafeleRedeemDetail(sendremark = false) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          id: vm.item.id,
          status: vm.status.value,
          remark: vm.item.remark ? vm.item.remark : '',
          sendremark: sendremark
        }
        api.saveHafeleRedeemDetail(data, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }

          resolve()
        })
      })
    }
  },
  watch: {
    value: {
      handler(newVal) {
        var vm = this
        var status = vm.statusOption.find((el) => {
          return el.value == vm.item.status
        })
        if (status) {
          vm.status = status
        } else {
          vm.status = vm.statusOption[0]
        }
        vm.item = newVal
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/hafele/OrderSummaryItem.vue